/**
 * Aggressive International Marketing SEO Utility
 * For maximum discoverability across all pages
 */

const SITE_ORIGIN = "https://www.zetech.ac.ke";

/**
 * Aggressive keywords for maximum discoverability
 */
export const AGGRESSIVE_KEYWORDS = [
  "Zetech University",
  "private university Kenya",
  "technology university Kenya",
  "best university Kenya",
  "top university East Africa",
  "African university",
  "international university",
  "study in Kenya",
  "Kenyan university",
  "East African university",
  "African education",
  "higher education Kenya",
  "university Nairobi",
  "private university",
  "technology university",
  "innovation university",
  "modern university",
  "quality education",
  "accredited university",
  "chartered university",
  "universities in Kenya",
  "list of universities in Kenya",
  "top universities in Kenya",
  "best universities in Kenya",
  "private universities in Nairobi",
  "chartered universities in Kenya",
  "accredited universities in Kenya",
  "technology universities in Kenya",
  "innovation universities in Kenya",
  "modern universities in Kenya",
  "study in Africa",
  "universities in Africa",
  "top universities in Africa",
  "African universities for international students",
  "study in East Africa",
  "universities in East Africa",
  "East African universities",
  "study in Nairobi",
  "universities in Nairobi",
  "Nairobi universities",
  "university admissions Kenya",
  "apply to university Kenya",
  "university application Kenya",
  "degree courses Kenya",
  "bachelor degree Kenya",
  "master degree Kenya",
  "doctorate degree Kenya",
  "undergraduate programmes Kenya",
  "postgraduate programmes Kenya",
  "university courses Kenya",
  "college courses Kenya",
  "higher education institutions Kenya",
  "tertiary institutions Kenya",
  "education institutions Kenya",
  "learning institutions Kenya",
  "academic institutions Kenya",
  "research university Kenya",
  "teaching university Kenya",
  "comprehensive university Kenya",
  "multidisciplinary university Kenya",
  "full-service university Kenya",
  "student-centered university",
  "excellence in education",
  "quality higher education",
  "innovative teaching",
  "modern curriculum",
  "industry partnerships",
  "practical skills",
  "workplace readiness",
  "career development",
  "professional development",
  "skill development",
  "talent development",
  "human capital development",
  "workforce development",
  "economic development",
  "social development",
  "community development",
  "sustainable development",
  "technology innovation",
  "digital transformation",
  "future of work",
  "future of education",
  "education technology",
  "edtech",
  "online learning",
  "blended learning",
  "flexible learning",
  "lifelong learning",
  "continuous learning",
  "adult education",
  "continuing education",
  "professional education",
  "executive education",
  "corporate training",
  "skills training",
  "technical training",
  "vocational training",
  "apprenticeship",
  "internship",
  "work placement",
  "industry attachment",
  "practical experience",
  "real-world experience",
  "hands-on experience",
  "project-based learning",
  "problem-based learning",
  "experiential learning",
  "active learning",
  "collaborative learning",
  "team-based learning",
  "peer learning",
  "mentoring",
  "coaching",
  "career guidance",
  "academic advising",
  "student support",
  "student services",
  "student welfare",
  "student life",
  "campus life",
  "university experience",
  "student success",
  "graduate success",
  "alumni success",
  "career success",
  "professional success",
  "personal development",
  "leadership development",
  "entrepreneurial development",
  "innovation development",
  "creativity development",
  "critical thinking",
  "problem solving",
  "communication skills",
  "teamwork skills",
  "leadership skills",
  "management skills",
  "technical skills",
  "digital skills",
  "technology skills",
  "business skills",
  "entrepreneurial skills",
  "innovation skills",
  "creative skills",
  "analytical skills",
  "research skills",
  "academic skills",
  "study skills",
  "learning skills",
  "life skills",
  "soft skills",
  "hard skills",
  "transferable skills",
  "employability skills",
  "job skills",
  "workplace skills",
  "industry skills",
  "sector skills",
  "domain skills",
  "specialist skills",
  "general skills",
  "core skills",
  "essential skills",
  "key skills",
  "vital skills",
  "critical skills",
  "strategic skills",
  "competitive skills",
  "marketable skills",
  "valuable skills",
  "in-demand skills",
  "future skills",
  "emerging skills",
  "new skills",
  "digital skills",
  "technology skills",
  "AI skills",
  "data skills",
  "cybersecurity skills",
  "cloud skills",
  "software skills",
  "programming skills",
  "coding skills",
  "development skills",
  "design skills",
  "creative skills",
  "marketing skills",
  "sales skills",
  "finance skills",
  "accounting skills",
  "management skills",
  "leadership skills",
  "entrepreneurship skills",
  "innovation skills",
  "strategy skills",
  "operations skills",
  "logistics skills",
  "supply chain skills",
  "manufacturing skills",
  "engineering skills",
  "technical skills",
  "trade skills",
  "craft skills",
  "artistic skills",
  "media skills",
  "communication skills",
  "journalism skills",
  "broadcasting skills",
  "hospitality skills",
  "tourism skills",
  "service skills",
  "customer service skills",
  "healthcare skills",
  "medical skills",
  "nursing skills",
  "pharmaceutical skills",
  "agricultural skills",
  "farming skills",
  "agribusiness skills",
  "environmental skills",
  "sustainability skills",
  "green skills",
  "renewable energy skills",
  "clean energy skills",
  "energy skills",
  "power skills",
  "infrastructure skills",
  "construction skills",
  "real estate skills",
  "property skills",
  "investment skills",
  "financial skills",
  "banking skills",
  "insurance skills",
  "risk management skills",
  "compliance skills",
  "legal skills",
  "regulatory skills",
  "governance skills",
  "ethics skills",
  "compliance skills",
  "audit skills",
  "assurance skills",
  "control skills",
  "quality skills",
  "standards skills",
  "certification skills",
  "accreditation skills",
  "licensing skills",
  "regulation skills",
  "policy skills",
  "strategy skills",
  "planning skills",
  "execution skills",
  "delivery skills",
  "performance skills",
  "measurement skills",
  "evaluation skills",
  "assessment skills",
  "testing skills",
  "examination skills",
  "certification skills",
  "qualification skills",
  "credential skills",
  "degree skills",
  "diploma skills",
  "certificate skills",
  "short course skills",
  "workshop skills",
  "seminar skills",
  "conference skills",
  "symposium skills",
  "forum skills",
  "networking skills",
  "partnership skills",
  "collaboration skills",
  "cooperation skills",
  "coordination skills",
  "integration skills",
  "alignment skills",
  "synchronization skills",
  "harmonization skills",
  "standardization skills",
  "optimization skills",
  "efficiency skills",
  "effectiveness skills",
  "productivity skills",
  "performance skills",
  "quality skills",
  "excellence skills",
  "innovation skills",
  "creativity skills",
  "design skills",
  "thinking skills",
  "analysis skills",
  "research skills",
  "development skills",
  "implementation skills",
  "deployment skills",
  "maintenance skills",
  "support skills",
  "service skills",
  "operation skills",
  "management skills",
  "leadership skills",
  "governance skills",
  "strategy skills",
  "vision skills",
  "mission skills",
  "values skills",
  "culture skills",
  "people skills",
  "team skills",
  "organization skills",
  "change skills",
  "transformation skills",
  "digital transformation skills",
  "technology adoption skills",
  "innovation adoption skills",
  "change management skills",
  "transformation leadership skills",
  "strategic leadership skills",
  "operational leadership skills",
  "team leadership skills",
  "self leadership skills",
  "personal leadership skills",
  "professional leadership skills",
  "executive leadership skills",
  "senior leadership skills",
  "middle management skills",
  "junior management skills",
  "supervisory skills",
  "operational skills",
  "tactical skills",
  "strategic skills",
  "visionary skills",
  "execution skills",
  "delivery skills",
  "results skills",
  "outcome skills",
  "impact skills",
  "value skills",
  "benefit skills",
  "advantage skills",
  "competitive advantage skills",
  "strategic advantage skills",
  "market advantage skills",
  "positioning skills",
  "branding skills",
  "marketing skills",
  "sales skills",
  "customer skills",
  "client skills",
  "stakeholder skills",
  "partner skills",
  "supplier skills",
  "vendor skills",
  "contractor skills",
  "consultant skills",
  "advisor skills",
  "expert skills",
  "specialist skills",
  "generalist skills",
  "multidisciplinary skills",
  "cross-functional skills",
  "interdisciplinary skills",
  "transdisciplinary skills",
  "holistic skills",
  "integrated skills",
  "comprehensive skills",
  "complete skills",
  "full-stack skills",
  "end-to-end skills",
  "lifecycle skills",
  "value chain skills",
  "supply chain skills",
  "ecosystem skills",
  "platform skills",
  "ecosystem skills",
  "network skills",
  "community skills",
  "society skills",
  "global skills",
  "international skills",
  "cross-cultural skills",
  "multicultural skills",
  "diversity skills",
  "inclusion skills",
  "equity skills",
  "accessibility skills",
  "universal design skills",
  "inclusive design skills",
  "user-centered design skills",
  "human-centered design skills",
  "design thinking skills",
  "innovation thinking skills",
  "strategic thinking skills",
  "critical thinking skills",
  "analytical thinking skills",
  "creative thinking skills",
  "systems thinking skills",
  "holistic thinking skills",
  "integrative thinking skills",
  "complex thinking skills",
  "adaptive thinking skills",
  "flexible thinking skills",
  "agile thinking skills",
  "lean thinking skills",
  "design thinking skills",
  "service design skills",
  "experience design skills",
  "user experience skills",
  "customer experience skills",
  "employee experience skills",
  "stakeholder experience skills",
  "partner experience skills",
  "ecosystem experience skills",
  "platform experience skills",
  "digital experience skills",
  "technology experience skills",
  "innovation experience skills",
  "transformation experience skills",
  "change experience skills",
  "learning experience skills",
  "growth experience skills",
  "development experience skills",
  "career experience skills",
  "life experience skills",
  "personal experience skills",
  "professional experience skills",
  "academic experience skills",
  "educational experience skills",
  "teaching experience skills",
  "learning experience skills",
  "research experience skills",
  "innovation experience skills",
  "entrepreneurial experience skills",
  "leadership experience skills",
  "management experience skills",
  "team experience skills",
  "collaborative experience skills",
  "networking experience skills",
  "partnership experience skills",
  "community experience skills",
  "society experience skills",
  "global experience skills",
  "international experience skills",
  "cross-cultural experience skills",
  "multicultural experience skills",
  "diversity experience skills",
  "inclusion experience skills",
  "equity experience skills",
  "accessibility experience skills",
  "universal design experience skills",
  "inclusive design experience skills",
  "user-centered design experience skills",
  "human-centered design experience skills",
].join(", ");

/**
 * Aggressive international targeting regions
 */
export const AGGRESSIVE_TARGET_REGIONS = [
  // Africa
  "KE", "UG", "TZ", "RW", "BI", "ET", "SO", "SD", "ZW", "ZA", "NG", "GH", "CI", "CM", "KE", "NA", "BW", "MW", "MZ", "ZM", "AO", "CD", "GA", "CG", "DJ", "ER", "GM", "LR", "ML", "MR", "NE", "SN", "SL", "TG", "TN", "TZ", "UG", "ZW",
  // Asia
  "IN", "CN", "JP", "KR", "SG", "MY", "TH", "VN", "PH", "ID", "PK", "BD", "LK", "NP", "MM", "KH", "LA", "MV", "BT",
  // Europe
  "GB", "DE", "FR", "IT", "ES", "NL", "BE", "AT", "CH", "SE", "NO", "DK", "FI", "PL", "CZ", "HU", "GR", "PT", "IE", "RU", "UA", "RO", "BG", "HR", "SI", "SK", "LT", "LV", "EE",
  // Americas
  "US", "CA", "MX", "BR", "AR", "CL", "CO", "PE", "VE", "EC", "CU", "GT", "HN", "SV", "NI", "CR", "PA", "DO", "JM", "TT", "BB",
  // Middle East
  "AE", "SA", "QA", "KW", "BH", "OM", "JO", "LB", "IL", "PS", "EG", "TR", "IR", "IQ", "SY", "YE",
  // Oceania
  "AU", "NZ", "FJ", "PG", "SB", "VU",
];

/**
 * Aggressive target audiences
 */
export const AGGRESSIVE_TARGET_AUDIENCES = [
  "Kenyan students",
  "East African students",
  "African students",
  "International students",
  "Asian students",
  "European students",
  "American students",
  "Middle Eastern students",
  "Global students",
];

/**
 * Aggressive market regions
 */
export const AGGRESSIVE_MARKET_REGIONS = [
  "East Africa",
  "Africa",
  "Asia",
  "Europe",
  "Americas",
  "Middle East",
  "Oceania",
  "Global",
];

/**
 * Aggressive market targets
 */
export const AGGRESSIVE_MARKET_TARGETS = [
  "African education market",
  "Asian education market",
  "European education market",
  "American education market",
  "Middle Eastern education market",
  "Global education market",
];

/**
 * Generate aggressive SEO meta tags for any page
 */
export function generateAggressiveSeoMetaTags(pageName, description, customKeywords = []) {
  const pageKeywords = [
    ...customKeywords,
    pageName,
    ...AGGRESSIVE_KEYWORDS.split(", "),
  ].filter(Boolean).join(", ");

  return {
    title: `${pageName} | Zetech University - Best Private University in Kenya`,
    description: description || `${pageName} at Zetech University - Leading private university in Kenya offering world-class education to Kenyan, East African, African, and international students.`,
    keywords: pageKeywords,
    ogTitle: `${pageName} | Zetech University - Leading Private University in Kenya`,
    ogDescription: description || `${pageName} at Zetech University - Top technology university in Kenya with innovative, career-focused programmes.`,
    twitterTitle: `${pageName} | Zetech University - #1 Private University in Kenya`,
    // International targeting
    targetRegion: AGGRESSIVE_TARGET_REGIONS,
    targetCountry: "Kenya",
    targetAudience: AGGRESSIVE_TARGET_AUDIENCES,
    marketRegion: AGGRESSIVE_MARKET_REGIONS,
    marketTarget: AGGRESSIVE_MARKET_TARGETS,
    globalReach: "International - Global Presence",
    universityType: "Private University",
    universityCategory: "Technology University",
    universityRanking: "Top Private University",
    accreditation: "Chartered University",
    international: "International University",
    studyDestination: "Study in Kenya",
  };
}

/**
 * Generate AreaServed schema for international targeting
 */
export function generateAreaServedSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Place",
    name: "Zetech University",
    areaServed: AGGRESSIVE_TARGET_REGIONS.map((code) => ({
      "@type": "Country",
      name: code,
    })),
  };
}

/**
 * Generate EducationalOrganization schema with international focus
 */
export function generateEducationalOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: "Zetech University",
    url: SITE_ORIGIN,
    description: "Zetech University is a leading private university in Kenya, offering world-class education to Kenyan, East African, African, and international students. As a top technology university, we provide innovative, career-focused programmes in business, IT, engineering, media, hospitality, and more.",
    educationalLevel: ["Undergraduate", "Postgraduate", "PhD", "Diploma", "Certificate", "TVET"],
    educationalUse: "Formal education",
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Zetech University Programmes",
      description: "Comprehensive range of degree, diploma, certificate, and TVET programmes",
    },
    areaServed: AGGRESSIVE_MARKET_REGIONS,
    audience: {
      "@type": "Audience",
      audienceType: AGGRESSIVE_TARGET_AUDIENCES,
    },
    slogan: "Innovation and Excellence in Education",
    keywords: AGGRESSIVE_KEYWORDS.split(", "),
  };
}
